<template>
  <div :class="$style.root" role="radiogroup" :aria-label="groupLabel">
    <SCAButton
      v-for="option in options"
      :key="option.value"
      type="toggle"
      :appearance="model === option.value ? 'primary' : 'secondary'"
      size="small"
      :shadow="false"
      padding-left="4px"
      padding-right="4px"
      role="radio"
      :aria-checked="model === option.value"
      :selected="model === option.value"
      :class="$style.option"
      :test-id="option.testId"
      @click="model = option.value"
    >
      {{ option.label }}
    </SCAButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SCAButton from "../../SCAButton.vue";
import { LogicalOperator } from "../filterModel";
import { joinLabel } from "./operators";

const model = defineModel<LogicalOperator>({ required: true });

const options = computed(() => [
  { value: LogicalOperator.AND, label: joinLabel(LogicalOperator.AND), testId: "column-filter-join-and" },
  { value: LogicalOperator.OR, label: joinLabel(LogicalOperator.OR), testId: "column-filter-join-or" },
]);

const groupLabel = computed(() => options.value.map((option) => option.label).join(" / "));
</script>

<style module lang="scss">
.root {
  display: flex;
  width: 100%;
  gap: var(--space-component-gap-xSmall);
  margin: var(--space-component-padding-small) 0;
}

.option {
  min-width: 40px;
}

.root .option,
.root .option * {
  cursor: pointer;
}
</style>
